import React from 'react';

import Card from '../../../Card';
import BaseSkeleton from '../BaseSkeleton';
import Divider from '../../../Divider';

import { ListSkeletonProps } from './ListSkeleton.types'

const ListSkeleton: React.FC<ListSkeletonProps> = ({
  className,
  list,
}) => {

  const textContent = (textClassName='') => {
    return (
      <div className={`flex flex-column ${textClassName} `}>
        <BaseSkeleton width={100} className='mb1' />
        <BaseSkeleton width={200} />
      </div>
    )
  }

  const getList = () => {
    return  list?.map((item, index) => (
      <>
      {item?.title && (<BaseSkeleton width={300} height={40} className={`mx4 ${item?.subtitle ? '' : 'mb2'} `} />)}
      {item?.subtitle && (<BaseSkeleton width={300} height={20} className='mb2 mx4' />)}
      {index < list?.length - 1 ? <Divider /> : null}
      </>
  ))
  }

  return (
    <Card className={`flex flex-column width-100 ${className}`}>
       {getList()}
    </Card>
  );
};

export default ListSkeleton;
export { ListSkeletonProps };
